<script>
import { createNamespacedHelpers } from 'vuex';
import { ScToast } from '@intelipost-js/secure-components';

import BillingLoadingModal from '../../../components/billing-loading-modal/BillingLoadingModal.vue';
import ScConfirmationModal from '../../../../../components/sc-confirmation-modal/ScConfirmationModal.vue';

const { mapState } = createNamespacedHelpers('recon/billing');


export default {
  name: 'BillingUploadSavingModal',
  data() {
    return {
      hasSaveError: false,
      isErrorModalActive: false,
    };
  },
  methods: {
    postUploadMessage() {
      const suffixWithLink = "<a href='/recon/billing/files'><strong><u>Meus Arquivos > Faturas adicionadas</u></strong></a>";
      return `A fatura enviada está sendo processada. O status do processamento estará disponível para consulta em ${suffixWithLink}.`;
    },
  },
  computed: {
    ...mapState(['savingBillingUpload', 'savingBillingUploadError']),
  },
  watch: {
    savingBillingUploadError(error) {
      if (error) {
        const isExpectedError = error.indexOf('billing.duplicated.for.logisticProvider') !== -1;
        this.hasSaveError = !isExpectedError;
        this.isErrorModalActive = isExpectedError;
      }
    },
    savingBillingUpload(isSaving) {
      if (!isSaving && !this.isErrorModalActive) {
        ScToast.open({ message: this.postUploadMessage(), duration: 20000, type: 'is-success' });
        this.$router.push({ name: 'billing-my-files-page' });
      }
    },
  },
  components: { ScConfirmationModal, BillingLoadingModal, ScToast },
};
</script>

<template>
  <section>
    <billing-loading-modal text="Aguarde o upload da fatura." :is-active="savingBillingUpload"/>
    <sc-confirmation-modal
      :is-active.sync="isErrorModalActive"
      type="primary"
      title="Adicionar ou reenviar fatura?"
      cancelText="Adicionar fatura"
      confirm-text="Reenviar fatura"
      @onConfirm="() => $emit('onOverwriteBilling')"
      @onCancel="() => $emit('onDuplicateBilling')"
    >
      <template slot="default">
        <p style="margin-bottom: 16px">Observamos que a fatura que está sendo adicionada possui a mesma data de vencimento e
          transportadora de uma fatura já registrada no sistema. Você prefere reenviar a fatura ou adicionar uma nova?
        </p>
        <p><strong>Reenviar fatura:</strong> Isso substituirá a fatura existente pelo arquivo que está sendo adicionado.</p>
        <p><strong>Adicionar fatura:</strong> Isso permitirá que você visualize ambas as faturas da mesma transportadora</p>
      </template>
    </sc-confirmation-modal>
  </section>
</template>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/upload/components/BillingUploadSavingModal.vue?fc68d53c